export default "__VITE_ASSET__BBfJt$Hk__"